/**
 * FullStacked Cloud - Console Web Management Portal (React 19 entrypoint).
 */

import { createRoot } from "react-dom/client";
import { Boot } from "./src/bootstrap.tsx";
import "./index.css";

const rootEl = document.getElementById("root");
if (rootEl) createRoot(rootEl).render(<Boot />);
